import { cn } from '@/lib/utils';
import { Card } from '@/components/ui/Card.tsx';
import { Skeleton } from '@/components/ui/Skeleton.tsx';

interface DetailsHeaderSkeletonProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Liczba zakładek do odwzorowania. */
  tabCount?: number;
  /** Rezerwuje miejsce na pasek stanu pod zakładkami. */
  withBanner?: boolean;
}

/** Szkielet nagłówka ekranu rekordu — te same piętra co `DetailsHeader`. */
const DetailsHeaderSkeleton = ({
  tabCount = 2,
  withBanner = false,
  className,
  ...props
}: DetailsHeaderSkeletonProps) => (
  <Card className={cn('overflow-hidden', className)} {...props}>
    <div className="flex items-center gap-3.5 px-7 py-5">
      <Skeleton className="size-11 rounded-full" />
      <div className="flex flex-col gap-1.5">
        <Skeleton className="h-[22px] w-56" />
        <Skeleton className="h-4 w-80" />
      </div>
      <div className="ml-auto flex items-center gap-2.5">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-[26px] w-11 rounded-full" />
      </div>
    </div>

    <div className="flex gap-[26px] border-t border-neutral-100 px-7 py-[13px]">
      {Array.from({ length: tabCount }).map((_, index) => (
        <Skeleton key={index} className="h-5 w-24" />
      ))}
    </div>

    {withBanner && (
      <div className="flex items-center gap-3.5 border-t border-neutral-100 bg-neutral-50 px-7 py-3.5">
        <Skeleton className="size-[9px] rounded-full" />
        <div className="flex flex-col gap-1.5">
          <Skeleton className="h-4 w-96" />
          <Skeleton className="h-3.5 w-80" />
        </div>
        <Skeleton className="ml-auto h-9 w-36 rounded-lg" />
      </div>
    )}
  </Card>
);

export default DetailsHeaderSkeleton;
